import { render, staticRenderFns } from "./Hongyun.vue?vue&type=template&id=1fa3e798&scoped=true&"
import script from "./Hongyun.vue?vue&type=script&lang=js&"
export * from "./Hongyun.vue?vue&type=script&lang=js&"
import style0 from "./Hongyun.vue?vue&type=style&index=0&id=1fa3e798&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3e798",
  null
  
)

component.options.__file = "Hongyun.vue"
export default component.exports